import { createApiHooks } from '@apis/next/common';
import { ArrivalNoticeLog } from '@models/next/ArrivalNoticeLog';
import { makeApi } from '@zodios/core';
import { z } from 'zod';

const apis = makeApi([
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
    ],
    response: ArrivalNoticeLog.array(),
  },
]);

export const arrivalNoticeLogApis = createApiHooks('/arrival-notice-log', apis);

export const dashboardArrivalNoticeLogApis = createApiHooks('/dashboard/arrival-notice-log', apis);
